import React from 'react';

import { SkeletonTheme } from 'react-loading-skeleton';

import { ThemeConsumer } from '../../contexts/themeContext';
import 'react-loading-skeleton/dist/skeleton.css';

/**
 * WithSkeletonTheme
 * @param {Object} props
 * @returns {JSX}
 */
export default function WithSkeletonTheme(props) {
  return (
    <ThemeConsumer>
      {({ themes }) => (
        <SkeletonTheme baseColor={themes.skeletonColor} highlightColor={themes.skeletonHighlight}>
          {props.children}
        </SkeletonTheme>
      )}
    </ThemeConsumer>
  );
}
